<template>
  <div class="room" :id="code" :class="{ highlight: isOpen }">
    <div class="room-body row mr-0 ml-0">
      <div class="col-sm-12 col-lg-5 col-xl-4 p-0">
        <div class="image-gallery">
          <div class="sticker sticker-few" v-if="$attrs.availability <= 3">
            {{ $t("rooms-left", { amount: $attrs.availability }) }}
          </div>
          <Swiper ref="imgSwipe" :loop="true" :slides-per-view="1" @swiper="setSwiperRef">
            <SwiperSlide v-for="(image, imageIndex) in $attrs.mediums" v-bind:key="image"><img :src="image"
                class="img-fluid offer-image" :key="imageIndex" /></SwiperSlide>
          </Swiper>
          <button class="prev-image" @click="swiperRef.slidePrev()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="10" transform="rotate(-180 10 10)" fill="white" />
              <path d="M10.8334 8.33329L9.16671 9.99996L10.8334 11.6666" stroke="#A34F8B" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
          <button class="next-image" @click="swiperRef.slideNext()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="10" fill="white" />
              <path d="M9.16663 11.6667L10.8333 10L9.16663 8.33337" stroke="#A34F8B" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      </div>
      <div class="col-sm-12 col-lg-7 col-xl-8">
        <div class="room-description">
          <a class="more-info" @click="infoOpen = !infoOpen">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="#8D87EC"/>
                    </svg>
                    {{ $t("equipment") }}
                  </a>
          <div class="row h-100">
            <div class="col-12">
              
              <h2 class="h2 mb-2">
                {{ name }} 

                
              </h2>
              <!-- !!! Commented according to the Figma -->
              <!-- <p class="card-text">{{ teaser }}</p> -->
              <!-- <ul class="room-attributes">
                <li class="" v-for="(art, index) in $attrs.arts" :key="index" :title="art">{{ art.title }}</li>
              </ul> -->
              <div class="moreinfo-wrap" data-lenis-prevent>
                <div class="moreinfo" v-if="infoOpen">
                  <div class="moreinfo-overlay" @click="infoOpen = !infoOpen"></div>
                  <div class="moreinfo-content" data-lenis-prevent>
                    <div class="moreinfo-image">
                      <div class="moreinfo-teaser">
                        <h1>{{ name }}</h1>
                        <p>{{ teaser }}</p>
                      </div>
                      <img class="img-fluid" :src="$attrs.mainImage" />
                    </div>
                    <div class="row text-start">
                      <div class="col-sm-6 moreinfo-description p-4">
                        <h2>{{ $t("expect") }}</h2>
                        <div v-html="$attrs.description"></div>
                        <img class="img-fluid mt-3" :src="$attrs.mediums[$attrs.mediums.length - 1]" />
                      </div>
                      <div class="col-sm-6 moreinfo-equipment p-4">
                        <h2>{{ $t("equipment") }}</h2>
                        <ul class="text-start">
                          <li v-for="item in $attrs.equipment.split(',')" :key="item">{{ item }}</li>
                        </ul>
                      </div>
                    </div>
                    <div @click="infoOpen = !infoOpen" class="moreinfo-close btn-delete">
                      <span></span>
                    </div>
                  </div>
                </div>
                <InclusiveServices v-if="additionalInfoOpen" @closeClicked="closeAdditionalInfo"></InclusiveServices>
              </div>
            </div>
            <div class="col-12 mt-auto">
              <!-- TODO - Please add word Personen (following paragraph) to Translation list -->
              <p class="mb-2">{{ $attrs.size }}<span class="mx-4">•</span>{{ $attrs.minimum_occupancy }} - {{ $attrs.maximum_occupancy }} Personen</p>
              <p class="mb-2">
                <span v-if="nights == 1">{{ $t("price-for") }} {{ nights }} {{ $t("night") }}</span>
                <span v-else>{{ $t("price-for") }} {{ nights }} {{ $t("nights") }}</span>
              </p>
              <p class="mb-2">{{ params.adults }} <span v-if="params.adults == 1">
                    {{ $t("adult") }}
                  </span>
                  <span v-else>
                    {{ $t("adults") }}
                  </span>
                  <br />
                  <span v-if="params.children != ''">
                    <span v-if="params.children.split(';').length == 1">
                      {{ params.children.split(";").length }} {{ $t("child") }}
                    </span>
                    <span v-else>
                      {{ params.children.split(";").length }} {{ $t("children") }}
                    </span>
                  </span>
                  <!-- bernd change end -->
              </p>
              <p><strong>{{ toPrice($attrs.lowest_price) }}</strong></p>
            </div>
            <div class="col-12 mt-auto mb-auto text-start text-left">
              <button class="btn btn-primary" :class="{ open: isOpen }"
                @click="isOpen = !isOpen; scrollToElement(code);">
                {{ isOpen ? closeText : openText }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 price-list" :class="{ open: isOpen }">
        <hr class="my-4" style="background-color: #8D87EC; height: 1px; opacity: 1;">
        <div class="price-list-options" :id="'price-list' + code">
          <div class="text-start">
            <h3>{{ $t("onlyForYou") }} 
              <!-- <br>{{ findOfferTitle(Object.keys($attrs.prices)[0]) }} <a class="more-info"
                      @click="additionalInfoOpen = !additionalInfoOpen">
                      xxx<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="#8D87EC"/>
      </svg>
                    </a> -->
                  </h3>
                  <div v-html="findOfferDescription(Object.keys($attrs.prices)[0])"></div>
          </div>
          <!-- <div class="row align-items-start">
            
            <div class="col-12 col-sm-6 ml-auto ms-auto">
              <div class="row align-items-center">
                <div class="col-12 text-right text-end" v-if="isBetweenLastWeek(params.dateFrom)">
                  <p class="text-success">Sie können diese Buchung bis zum <stong>{{ isBetweenLastWeek(params.dateFrom) }}
                    </stong> kostenlos stornieren. last week</p>
                </div>
                <div class="col-12 text-right text-end" v-if="isBetweenLastThreeMonths(params.dateFrom)">
                  <p class="text-success">Sie können diese Buchung bis zum <stong>{{ isBetweenLastThreeMonths(params.dateFrom) }}
                    </stong> kostenlos stornieren. 3 months</p>
                </div>
                <div class="col-12 text-right text-end" v-if="isBetweenStornoDate(params.dateFrom)">
                  <p class="text-success">{{ $t("storno1") }} <stong>{{ isBetweenStornoDate(params.dateFrom) }} </stong>
                    {{ $t("storno2") }} </p>
                </div>
              </div>
              <hr>
              <p class="text-right text-end mb-3">
                <stong> {{ $t("inquiry-not-sure") }} </stong><br> {{ $t("inquiry-contact-us") }}
              </p>
              
            </div> 
          </div>-->
          <div class="price-list-options-footer">
            <div class="row">

              <div class="col-sm-12 col-md-6 mb-sm-4 mb-md-0">
                <button class="btn btn-primary btn-small" @click="linkToInquery()">
                  {{ $t("inquiry") }}
                </button>
              </div>

              <div class="col-sm-12 col-md-6">
                <div class="d-flex justify-content-end align-items-center ">
                <h5 class="pl-6"><span class="px-4">{{ toPrice(Object.values($attrs.prices)[0].total) }}</span></h5>
                  <button class="btn btn-primary btn-small btn-gradient"
                    @click="selectedRoom(Object.values($attrs.prices)[0].total, Object.keys($attrs.prices)[0])">
                    {{ $t("book") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>

      
    </div>
  </div>
</template>
<script>
//import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
  // Import Swiper Vue.js components
  import { Swiper, SwiperSlide } from 'swiper/vue';
  // Import Swiper styles
  import 'swiper/css';
import InclusiveServices from "./InclusiveServices.vue";
//import "swiper/swiper-bundle.css";


export default {
  name: "BookableListItem",
  components: {
    Swiper,
    SwiperSlide,
    InclusiveServices
  },
  props: {
    params: Array,
    nights: Number,
    name: String,
    teaser: String,
    code: String,
    visible: Boolean,
    selected: Boolean,
    adults: String,
    childrenages: Array,
    apikey: String,
  },
  data() {
    return {
      price: null,
      swiperRef: null,
      isOpen: false,
      infoOpen: false,
      additionalInfoOpen: false,
      openText: this.$t("prices-packages-show"),
      closeText: this.$t("prices-packages-hide"),
    };
  },
  computed: {
    isSelected() {
      return this.selected;
    },
    isOpenText() {
      return this.$t("price-from");
    },
  },
  watch: {
    infoOpen: function () {
      if (this.infoOpen) {
        document.body.classList.add("info-open");
      } else {
        document.body.classList.remove("info-open");
      }
    },
    additionalInfoOpen: function () {
      if (this.additionalInfoOpen) {
        document.body.classList.add("info-open");
      } else {
        document.body.classList.remove("info-open");
      }
    },
  },
  methods: {
    closeAdditionalInfo() {
      this.additionalInfoOpen = false;
    },
    findOfferTitle(code) {
      var idx = this.$attrs.ratePlans.findIndex((obj) => obj.code == code);
      return this.$attrs.ratePlans[idx].title;
    },
    findOfferDescription(code) {
      var idx = this.$attrs.ratePlans.findIndex((obj) => obj.code == code);
      return this.$attrs.ratePlans[idx].description;
    },
    setSwiperRef(swiper) {
      this.swiperRef = swiper;
    },

    slideTo(index) {
      this.swiperRef.slideTo(index - 1, 0);
    },
    selectedRoom(p, rateplan) {
      var params = { code: this.code, price: p, rateplan: rateplan };
      this.trackEvent('Booking', 'Buchen in Liste Clicked', this.name);
      this.$emit("selectedRoom", params);
    },

    linkToInquery() {

      var childrenAges = this.params.children;
      var childrenForGetParameter = childrenAges.replace(/;/g, ':');

      this.trackEvent('Booking', 'Anfrage in Liste Clicked', this.name);

      var inquiryUrl = this.url + "/buchen/anfrage";

      if (this.$i18n.locale == "en") {
        inquiryUrl = this.url + "/online-booking/inquiry";
      } 
      // ?room=Suite+Steinberg&startDate=2024-03-11&endDate=2024-03-13
      // ?room=Suite+Steinberg&startDate=2024-03-11&endDate=2024-03-13$adults=2&children=2,3,4

      var docUrl = inquiryUrl + "?room=" + this.name + "&startDate=" + this.params.dateFrom + "&endDate=" +this.params.dateTo + "&adults=" + this.params.adults + "&children=" + childrenForGetParameter;
      // var docUrl =
      //   inquiryUrl + this.params.dateFrom + ";" +
      //   this.params.dateTo + ";" +
      //   this.name +
      //   ";" +
      //   this.params.adults +
      //   ";" +
      //   childrenForGetParameter;

      // remove semicolon if at the end
      docUrl = docUrl.replace(/;$/, '');


      window.open(docUrl, '_blank');

      // window.location.href = docUrl;

    },
  },
};
</script>